import type { OutreachCrmTab } from '../../search';
import { useCrmViewParam } from '../../useCrmViewParam';
import { UnderlineTabNav, type UnderlineTab } from '../../../components/common/UnderlineTabNav';
import { CrmCreatorsTab } from './CrmCreatorsTab';
import { CrmOverviewTab } from './CrmOverviewTab';

export interface CrmViewProps {
  campaignId: string;
}

/** Scoped to one campaign by owner decision (2026-10-14); Figma's "across every campaign" copy is replaced. */
export const CRM_SUBTITLE = 'This campaign’s creators, from first email to signed.';

const CRM_TABS: readonly UnderlineTab<OutreachCrmTab>[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'creators', label: 'Creators' },
];

const TAB_PANEL_ID: Record<OutreachCrmTab, string> = {
  overview: 'outreach-crm-overview',
  creators: 'outreach-crm-creators',
};

/** The Figma CRM shell: header, Overview / Creators tabs, and the active tab's panel. */
export function CrmView({ campaignId }: CrmViewProps) {
  const { tab, setTab } = useCrmViewParam();
  const activeLabel = CRM_TABS.find((t) => t.key === tab)?.label ?? '';

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-medium text-foreground">CRM</h1>
        <p className="mt-0.5 text-sm text-muted-foreground">{CRM_SUBTITLE}</p>
      </header>
      <div className="border-b border-border">
        <UnderlineTabNav tabs={CRM_TABS} active={tab} onChange={setTab} />
      </div>
      <section id={TAB_PANEL_ID[tab]} role="tabpanel" aria-label={activeLabel}>
        {tab === 'overview' ? <CrmOverviewTab campaignId={campaignId} /> : <CrmCreatorsTab campaignId={campaignId} />}
      </section>
    </div>
  );
}
